var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./task.constants";
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, getCreatedDetail = _a.getCreatedDetail, 
// getInfiniteLoad,
isCreating = _a.isCreating, createError = _a.createError, isUpdating = _a.isUpdating, updateError = _a.updateError, isRemoving = _a.isRemoving, removeError = _a.removeError, isArchiving = _a.isArchiving, archivingError = _a.archivingError;
